// import React, { useState } from 'react';
// import { Card, Form, Button } from 'react-bootstrap'; // Adjust import as per your setup
// import axios from 'axios'; // Ensure Axios is imported
// import { API_BASE_URL } from '../../utils';

// function Updatepasswordprofilepage() {
//   const [error, setError] = useState(null);
//   const [show, setShow] = useState(false);
//   const handleChangePassword = async (e) => {
//     e.preventDefault();
//     const { currentPassword, newPassword, confirmPassword } = e.target.elements;

//     const adminId = localStorage.getItem('accessToken');

//     if (!adminId) {
//       // Handle case where user is not logged in
//       // Example: navigate('/login');
//       return;
//     }

//     if (newPassword.value !== confirmPassword.value) {
//       setError('Passwords do not match');
//       return;
//     }

//     const headers = {
//       Authorization: `Bearer ${adminId}`,
//       'Content-Type': 'application/json',
//     };

//     try {
//       const response = await axios.post(`${API_BASE_URL}/admin/changepassword`, {
//         currentPassword: currentPassword.value,
//         newPassword: newPassword.value,
//       }, { headers });

//       console.log('Password changed successfully:', response.data);
//       setError(null);
//       // Optionally, reset form fields or show success message
//     } catch (error) {
//       setError('Failed to change password. Please try again.');
//       console.error('Error changing password:', error);
//     }
//   };
//   const handleShow = () => setShow(true);
//   return (
//     <div>
//       <div className="col-md-6 "  onClick={handleShow}>
//         <Card style={{ width: '18rem', marginTop: '1rem' }} show={show}>
//           <Card.Body>
//             <Card.Title>Change Password</Card.Title>
//             <Form onSubmit={handleChangePassword}>
//               <Form.Group controlId="currentPassword">
//                 <Form.Label>Current Password</Form.Label>
//                 <Form.Control type="password" placeholder="Enter current password" required />
//               </Form.Group>

//               <Form.Group controlId="newPassword">
//                 <Form.Label>New Password</Form.Label>
//                 <Form.Control type="password" placeholder="Enter new password" required />
//               </Form.Group>

//               <Form.Group controlId="confirmPassword">
//                 <Form.Label>Confirm New Password</Form.Label>
//                 <Form.Control type="password" placeholder="Confirm new password" required />
//               </Form.Group>

//               {error && <p className="text-danger">{error}</p>}

//               <Button variant="primary" type="submit">
//                 Change Password
//               </Button>
//             </Form>
//           </Card.Body>
//         </Card>
//       </div>
//     </div>
//   );
// }

// export default Updatepasswordprofilepage;
// import React, { useState } from 'react';
// import { Card, Form, Button } from 'react-bootstrap'; // Adjust import as per your setup
// import axios from 'axios'; // Ensure Axios is imported
// import { API_BASE_URL } from '../../utils'; // Adjust path as per your project structure

// function Updatepasswordprofilepage() {
//   const [error, setError] = useState(null);
//   const [show, setShow] = useState(false);

//   const handleChangePassword = async (e) => {
//     e.preventDefault();
//     const { currentPassword, newPassword, confirmPassword } = e.target.elements;

//     const adminId = localStorage.getItem('accessToken');

//     if (!adminId) {
//       // Handle case where user is not logged in
//       // Example: navigate('/login');
//       return;
//     }

//     if (newPassword.value !== confirmPassword.value) {
//       setError('Passwords do not match');
//       return;
//     }

//     const headers = {
//       Authorization: `Bearer ${adminId}`,
//       'Content-Type': 'application/json',
//     };

//     try {
//       const response = await axios.post(`${API_BASE_URL}/admin/changepassword`, {
//         currentPassword: currentPassword.value,
//         newPassword: newPassword.value,
//       }, { headers });

//       console.log('Password changed successfully:', response.data);
//       setError(null);
//       // Optionally, reset form fields or show success message
//     } catch (error) {
//       setError('Failed to change password. Please try again.');
//       console.error('Error changing password:', error);
//     }
//   };

//   const handleShow = () => setShow(true);

//   return (
//     <div>
//       <div className="col-md-6">
//         {show && (
//           <Card style={{ width: '18rem', marginTop: '1rem' }}>
//             <Card.Body>
//               <Card.Title>Change Password</Card.Title>
//               <Form onSubmit={handleChangePassword}>
//                 <Form.Group controlId="currentPassword">
//                   <Form.Label>Current Password</Form.Label>
//                   <Form.Control type="password" placeholder="Enter current password" required />
//                 </Form.Group>

//                 <Form.Group controlId="newPassword">
//                   <Form.Label>New Password</Form.Label>
//                   <Form.Control type="password" placeholder="Enter new password" required />
//                 </Form.Group>

//                 <Form.Group controlId="confirmPassword">
//                   <Form.Label>Confirm New Password</Form.Label>
//                   <Form.Control type="password" placeholder="Confirm new password" required />
//                 </Form.Group>

//                 {error && <p className="text-danger">{error}</p>}

//                 <Button variant="primary" type="submit">
//                   Change Password
//                 </Button>
//               </Form>
//             </Card.Body>
//           </Card>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Updatepasswordprofilepage;
// import React, { useState } from 'react';
// import { Card, Form, Button, Modal } from 'react-bootstrap'; // Adjust import as per your setup
// import axios from 'axios'; // Ensure Axios is imported
// import { API_BASE_URL } from '../../utils'; // Adjust path as per your project structure
// import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';

// import "./profilePage.scss"
// function Updatepasswordprofilepage() {
//     const [error, setError] = useState(null);
//     const [showForm, setShowForm] = useState(false);
//     const [oldPassword,setOldpassword]=useState("")
//     const [newpassword,setNewpassword]=useState("")
//     const [confirmPassword,setConfirmPassword]=useState("")
//     const handleChangePassword = async (e) => {
//         e.preventDefault();
//         const { oldPassword , newpassword, confirmPassword } = e.target.elements;

//         const adminId = localStorage.getItem('accessToken');

//         if (!adminId) {
//             // Handle case where user is not logged in
//             // Example: navigate('/login');
//             return;
//         }

//         if (newpassword !== confirmPassword) {
//             setError('Passwords do not match');
//             return;
//         }

//         const headers = {
//             Authorization: `Bearer ${adminId}`,
//             'Content-Type': 'application/json',
//         };

//         try {
//             const response = await axios.post(`${API_BASE_URL}/admin/changepassword`, {
//                 oldPassword:oldPassword,
//                 newpassword: newpassword
//             }, { headers });

//             console.log('Password changed successfully:', response.data);
//             setError(null);
//             // Optionally, reset form fields or show success message
//         } catch (error) {
//             setError('Failed to change password. Please try again.');
//             console.error('Error changing password:', error);
//         }
//     };

//     const toggleForm = () => setShowForm(!showForm);

//     return (
//         <div>


//             <EllipsisOutlined onClick={toggleForm} style={{ cursor: 'pointer' }} />

//                 <Modal show={showForm}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Change Password</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <Form onSubmit={handleChangePassword}>
//                             <Form.Group controlId="currentPassword">
//                                 <Form.Label>Current Password</Form.Label>
//                                 <Form.Control type={oldPassword} placeholder="Enter current password" required 
//                                 onChange={e => setOldpassword(e.target.value)}/>
//                             </Form.Group>

//                             <Form.Group controlId="newPassword">
//                                 <Form.Label>New Password</Form.Label>
//                                 <Form.Control type={newpassword} placeholder="Enter new password" required 
//                                 onChange={e => setNewpassword(e.target.value)} />
//                             </Form.Group>


//                             <Form.Group controlId="confirmPassword">
//                                 <Form.Label>Confirm New Password</Form.Label>
//                                 <Form.Control 
//                                 type={confirmPassword} 
//                                 placeholder="Confirm new password" required 
//                                 onChange={e => setConfirmPassword(e.target.value)} />
//                             </Form.Group>
//                             {error && <p className="text-danger">{error}</p>}
//                             <Button variant="primary" type="submit">
//                                 Change Password
//                             </Button>
//                         </Form>
//                     </Modal.Body>
//                     <Modal.Footer>

//                     </Modal.Footer>
//                 </Modal>

//         </div>
//     );
// }

// export default Updatepasswordprofilepage;
// -------------------------------------------------------------------------
import React, { useState } from 'react';
import { Card, Form, Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import { API_BASE_URL } from '../../utils';
import { EllipsisOutlined } from '@ant-design/icons';

import "./profilePage.scss";
import { useNavigate } from 'react-router-dom';

function Updatepasswordprofilepage() {
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [oldPassword, setOldpassword] = useState("");
    const [newpassword, setNewpassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [isChangingPassword, setIsChangingPassword] = useState(false);
    const navigate = useNavigate()
    const handleChangePassword = async (e) => {
        e.preventDefault();

        const accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
            navigate("/");
            return;
        }

        if (newpassword !== confirmPassword) {
            setPasswordError("Passwords do not match");
            return;
        }

        const headers = {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        };

        const passwordData = {
            oldPassword,
            newpassword,
        };

        axios
            .patch(`${API_BASE_URL}/admin/changepassword`, passwordData, { headers })
            .then((response) => {
                console.log("Password changed successfully:", response.data.data);
                setIsChangingPassword(false); // Hide change password form
                setOldpassword("");
                setNewpassword("");
                setConfirmPassword("");
                setPasswordError("");
                // Optionally: Show success message or update UI
            })
            .catch((error) => {
                console.error("Error changing password:", error);
                // Handle error: Display error message or handle specific errors
            });
    };


    const toggleForm = () => setShowForm(!showForm);

    return (
        <div>
            <EllipsisOutlined onClick={toggleForm} style={{ cursor: 'pointer' }}  className='fs-4'/>

            <Modal show={showForm} onHide={toggleForm}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleChangePassword}>
                        <Form.Group controlId="currentPassword">
                            <Form.Label>Current Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Enter current password"
                                required
                                value={oldPassword}
                                onChange={e => setOldpassword(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="newPassword">
                            <Form.Label>New Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Enter new password"
                                required
                                value={newpassword}
                                onChange={e => setNewpassword(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="confirmPassword">
                            <Form.Label>Confirm New Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Confirm new password"
                                required
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                            />
                        </Form.Group>
                        {error && <p className="text-danger">{error}</p>}
                        <Button variant="primary" type="submit">
                            Change Password
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Updatepasswordprofilepage;
